import React from 'react';
import { Navigate } from 'react-router-dom';

function NavigateError() {
  return <Navigate to="error" />;
}

export default NavigateError;
